module.exports = __webpack_public_path__ + "static/media/leather-boot.89b85474.svg";